import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'presto-video',
  styleUrl: 'presto-video.css',
  shadow: false,
})
export class PrestoVideo {
  @Prop({ mutable: true }) getRef?: (elm?: HTMLVideoElement) => void;
  @Prop() autoplay: boolean;
  @Prop() src: string;
  @Prop() preload: string;
  @Prop() poster: string;
  @Prop() player: any;
  @Prop() tracks: { label: string; src: string; srcLang: string }[];
  @Prop() playsinline: boolean;
  @Prop() provider: string;
  @Prop() crossorigin: string;

  render() {
    return (
      <video
        class={{
          'presto-player__player': true,
          'plyr__video-embed': ['youtube', 'vimeo'].includes(this.provider),
        }}
        part="video"
        ref={this.getRef}
        autoplay={this.autoplay}
        preload={this.preload}
        data-poster={this.poster}
        playsinline={this.playsinline}
        crossorigin={this.crossorigin || undefined}
      >
        <source src={this.src} />
        {!!this.tracks &&
          !!this.tracks.length &&
          this.tracks.map(track => <track kind="captions" label={track?.label ? track.label : 'Captions'} src={track?.src} srclang={track?.srcLang ? track?.srcLang : 'en'} />)}
      </video>
    );
  }
}
